import { render } from "./RegistroSanitarioNuevo.vue?vue&type=template&id=b61af978"
import script from "./RegistroSanitarioNuevo.vue?vue&type=script&lang=js"
export * from "./RegistroSanitarioNuevo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__